<template>
	<div class="announcement_wrap">
		<section class="announcement_form">
			<div class="row ">
				<div class="form-group col-sm-3 mb-4">
					<BaseInput
						name="Announcement"
						label="Announcement"
						type="text"
						v-model="data.announcement"
						class="form-control form-control-lg dashInput"
						rules="required"
						:required="true"
					/>
				</div>
				<div class="col-sm-3">
					<BaseMultiSelect
						@update:value="setForRole"
						:options="multiSelectState.rolesSelect"
						name="For Roles"
						mode="tags"
					/>
				</div>
				<div class="col-sm-3">
					<BaseMultiSelect
						@update:value="setForUsers"
						:options="multiSelectState.usersSelect"
						name="For Users"
						mode="tags"
					/>
				</div>
				<div class="col-sm-3">
					<BaseInput
						name="Valid Till"
						label="Valid Till"
						type="Date"
						v-model="data.validTill"
						class="form-control form-control-lg dashInput"
						rules="required"
						:required="true"
					/>
				</div>
				<div class="col-sm-3">
					<BaseButton
						class="btn btn-primary form-control form-control-lg"
						type="submit"
						label="Save Announcement"
						@on:Click="create()"
						:disabled="formState.disable"
						:loading="formState.isLoading"
					/>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
	import { reactive, inject, onMounted } from "vue";
	import { useRouter } from "vue-router";

	import API from "@/config/api";
	import toast from "@/config/toast";
	import Helper from "@/helpers/dataHelper";

	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseInput from "./BaseInput.vue";
	import BaseButton from "./BaseButton.vue"; 

	export default {
		name: "announcementCreate",

		components: {
			BaseMultiSelect,
			BaseInput,
			BaseButton
		},

		setup: () => {
			const store = inject("store");
			const router = useRouter();

			if (!store.state.auth.isAuth) router.push({ name: "Login"});

			const data = reactive({
				announcement: null,
				forRoles: [],
				forUsers: [],
				validTill: null,
			});

			const multiSelectState = reactive({
				roles: [],
				rolesSelect: Helper.roles.map((role) => ({
					value: role,
					label: role.replace(/_/g, " "),
				})),
				users: [],
				usersSelect: [],
			});

			const formState = reactive({
				isLoading: false,
				disable: false,
			});

			const removeState = () => Object.keys(data).map(key => data[key] = data[key]instanceof String ? null : [])

			const create = async() => {
				try {
					const announcement = await API.privateRequest.post("admin/announcements", data);
					
					removeState();
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			}

			

			const getUsers = async () => {
				try {
					const users = await API.privateRequest.get("/users?filter=1");
					multiSelectState.users = users.data.data;
					multiSelectState.usersSelect = users.data.data.map((item) => {
						return {
							value: item._id,
							label: `${item.firstName} ${item.lastName}`,
						};
					});
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};

			const setForRole = (payload) => {
				data.forRoles = [...payload];
				getUsers();
			};
			const setForUsers = (payload) => {
				data.forUsers = [...payload];
			};

			onMounted(
				() => {
					getUsers();
				}
			)

			return {
				data,
				multiSelectState,
				formState,
				setForRole,
				setForUsers,
				create,
			};
		},
	};
</script>
